package music.jammers.client.shared.app

import androidx.compose.runtime.Composable
import androidx.navigation.NavHostController
import androidx.navigation.compose.NavHost
import androidx.navigation.compose.composable
import androidx.navigation.compose.dialog
import androidx.navigation.compose.rememberNavController
import androidx.navigation.toRoute
import music.jammers.client.shared.admin.presentation.ui.ADMIN_SCREEN
import music.jammers.client.shared.admin.presentation.ui.AdminScreen
import music.jammers.client.shared.app.di.SharedComponent
import music.jammers.client.shared.auth.presentation.ui.LoginScreen
import music.jammers.client.shared.component.TheJammersTheme
import music.jammers.client.shared.component.member.info.legend.presentation.ui.MemberInfoLegendDialog
import music.jammers.client.shared.event.presentation.ui.CREATE_EVENT_SCREEN
import music.jammers.client.shared.event.presentation.ui.CreateEventScreen
import music.jammers.client.shared.event.presentation.ui.EDIT_EVENT_SCREEN
import music.jammers.client.shared.event.presentation.ui.EVENT_DETAILS_SCREEN
import music.jammers.client.shared.event.presentation.ui.EVENT_FREEZE_SCREEN
import music.jammers.client.shared.event.presentation.ui.EVENT_LIST_SCREEN
import music.jammers.client.shared.event.presentation.ui.EditEventScreen
import music.jammers.client.shared.event.presentation.ui.EventDetailsScreen
import music.jammers.client.shared.event.presentation.ui.EventFreezeScreen
import music.jammers.client.shared.event.presentation.ui.EventListScreen
import music.jammers.client.shared.event.track.presentation.ui.ADD_EVENT_TRACK_SCREEN
import music.jammers.client.shared.event.track.presentation.ui.AddEventTrackScreen
import music.jammers.client.shared.event.track.presentation.ui.EVENT_TRACK_DETAILS_SCREEN
import music.jammers.client.shared.event.track.presentation.ui.EventTrackDetailsScreen
import music.jammers.client.shared.profile.presentation.ui.PROFILE_SCREEN
import music.jammers.client.shared.profile.presentation.ui.ProfileScreen
import music.limasoul.client.shared.navigation.Navigation
import org.koin.dsl.module

@Composable
fun JammersApp() {
    TheJammersTheme {
        val navController = rememberNavController()

        SharedComponent.getKoin().loadModules(
            listOf(
                module {
                    single<NavHostController> {
                        navController
                    }
                }
            )
        )

        val screenAnalytics = SharedComponent.screenAnalytics

        NavHost(
            navController = navController,
            startDestination = Navigation.Event.List,
        ) {
            composable<Navigation.Profile> {
                screenAnalytics.onScreenOpen(PROFILE_SCREEN)
                ProfileScreen(null)
            }

            composable<Navigation.ProfileUser> { backStackEntry ->
                screenAnalytics.onScreenOpen(PROFILE_SCREEN)
                val userId = backStackEntry.toRoute<Navigation.ProfileUser>().id

                ProfileScreen(userId)
            }

            composable<Navigation.Event.List> {
                screenAnalytics.onScreenOpen(EVENT_LIST_SCREEN)
                EventListScreen()
            }

            composable<Navigation.Event.Create> {
                screenAnalytics.onScreenOpen(CREATE_EVENT_SCREEN)
                CreateEventScreen()
            }

            composable<Navigation.Event.Edit> { backStackEntry ->
                screenAnalytics.onScreenOpen(EDIT_EVENT_SCREEN)

                val eventId = backStackEntry.toRoute<Navigation.Event.Edit>().id

                EditEventScreen(eventId)
            }

            composable<Navigation.Event.Freeze> { backStackEntry ->
                screenAnalytics.onScreenOpen(EVENT_FREEZE_SCREEN)

                val eventId = backStackEntry.toRoute<Navigation.Event.Freeze>().id

                EventFreezeScreen(eventId)
            }

            composable<Navigation.Login> {
                LoginScreen()
            }

            composable<Navigation.Event.Details> { backStackEntry ->
                screenAnalytics.onScreenOpen(EVENT_DETAILS_SCREEN)

                val eventId = backStackEntry.toRoute<Navigation.Event.Details>().id

                EventDetailsScreen(eventId)
            }

            composable<Navigation.EventTrack.Create> { backStackEntry ->
                screenAnalytics.onScreenOpen(ADD_EVENT_TRACK_SCREEN)

                val eventId = backStackEntry.toRoute<Navigation.EventTrack.Create>().eventId

                AddEventTrackScreen(eventId)
            }

            composable<Navigation.EventTrack.Details> { backStackEntry ->
                screenAnalytics.onScreenOpen(EVENT_TRACK_DETAILS_SCREEN)

                val route = backStackEntry.toRoute<Navigation.EventTrack.Details>()
                val eventId = route.eventId
                val eventTrackId = route.trackId

                EventTrackDetailsScreen(eventId, eventTrackId)
            }

            composable<Navigation.Admin> {
                screenAnalytics.onScreenOpen(ADMIN_SCREEN)
                AdminScreen()
            }

            dialog<Navigation.EventTrack.MemberDialog> { backStackEntry ->
                val extended = backStackEntry.toRoute<Navigation.EventTrack.MemberDialog>().extended
                MemberInfoLegendDialog(extended)
            }
        }
    }
}